import { render } from "./LandingCta.vue?vue&type=template&id=50a24ca2"
import script from "./LandingCta.vue?vue&type=script&lang=js"
export * from "./LandingCta.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__